/**
 * Created by pandemio on 2/20/19.
 */
import React from 'react';
import {
    Media,
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem } from 'reactstrap';
import { Translate } from 'react-localize-redux';
import { NavLink } from 'react-router-dom';
import SessionManager from '../../custom-classes/session-manager';
import LanguageSelectorMenu from '../selectors/language-selector-menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faCogs, faSignOutAlt, faHome, faSignInAlt } from '@fortawesome/free-solid-svg-icons';

export default class NavbarDesktopTop extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false,
            isLoggedIn: SessionManager.getSession() != null && SessionManager.getSession().length > 0
        };
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    render() {
        return (
            <div>
                <Navbar expand="md" className="navbar-mobile navbar-landing" color="faded" dark>
                    <NavbarBrand href="/">
                        <Media src={require('../../img/logo-gs-a.png')} alt="Company logo"
                                                  className="logo-mob"/>
                    </NavbarBrand>
                    <NavbarToggler onClick={this.toggle} />

                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="ml-auto" navbar>
                            <NavItem>
                                <NavLink to="/" className="navbar-button">
                                    <FontAwesomeIcon icon={faHome} /> {' '}
                                    <Translate id="navbar.home" options={{renderInnerHtml: true}}/>
                                </NavLink>
                            </NavItem>

                            {
                                this.state.isLoggedIn ?
                                <NavItem>
                                    <NavLink to="/dashboard" className="navbar-button">
                                        <Translate id="navbar.dashboard" options={{renderInnerHtml: true}}/>
                                    </NavLink>
                                </NavItem> : null
                            }


                            <NavItem>
                                <NavLink to="/select-plan" className="navbar-button">
                                    {
                                        !this.state.isLoggedIn ?
                                            <Translate id="navbar.subscribe" options={{renderInnerHtml: true}}/>
                                            :
                                            <Translate id="navbar.add-new-plan" options={{renderInnerHtml: true}}/>
                                    }
                                </NavLink>
                            </NavItem>


                            <NavItem>
                                <NavLink to="/download" className="navbar-button">
                                    <Translate id="navbar.download" options={{renderInnerHtml: true}}/>
                                </NavLink>
                            </NavItem>

                            {
                                this.state.isLoggedIn ?
                                    <UncontrolledDropdown>
                                        <DropdownToggle nav caret>
                                            <Translate id="navbar.reports" options={{renderInnerHtml: true}}/>
                                        </DropdownToggle>
                                        <DropdownMenu right>
                                            <DropdownItem>
                                                <NavLink to="/report-results" className="navbar-button">
                                                    <Translate id="navbar.print-results" options={{renderInnerHtml: true}}/>
                                                </NavLink>
                                            </DropdownItem>
                                            <DropdownItem>
                                                <NavLink to="/report-average" className="navbar-button">
                                                    <Translate id="navbar.student-average" options={{renderInnerHtml: true}}/>
                                                </NavLink>
                                            </DropdownItem>

                                        </DropdownMenu>
                                    </UncontrolledDropdown>: null
                            }


                            {
                                this.state.isLoggedIn ?
                                    <UncontrolledDropdown>
                                        <DropdownToggle nav caret>
                                            <Translate id="navbar.users" options={{renderInnerHtml: true}}/>
                                        </DropdownToggle>
                                        <DropdownMenu right>
                                            <DropdownItem>
                                                <NavLink to="/profile-update" className="navbar-button">
                                                    <Translate id="navbar.update-students" options={{renderInnerHtml: true}}/>
                                                </NavLink>
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown> : null
                            }



                            {
                                this.state.isLoggedIn ?
                                    <NavItem>
                                        <NavLink to="/update-information" className="navbar-button">
                                            <FontAwesomeIcon icon={faCogs} /> {' '}
                                            <Translate id="navbar.settings" options={{renderInnerHtml: true}}/>
                                        </NavLink>
                                    </NavItem> : null
                            }

                            {
                                this.state.isLoggedIn ?
                                    <NavItem>
                                        <NavLink to="/login" className="navbar-button">
                                            <FontAwesomeIcon icon={faSignOutAlt} /> {' '}
                                            <Translate id="navbar.logout" options={{renderInnerHtml: true}}/>
                                        </NavLink>
                                    </NavItem> : null
                            }
                            {
                                !this.state.isLoggedIn ?
                                    <NavItem>
                                        <NavLink to="/login" className="navbar-button">
                                            <FontAwesomeIcon icon={faSignInAlt} /> {' '}
                                            <Translate id="navbar.login" options={{renderInnerHtml: true}}/>
                                        </NavLink>
                                    </NavItem> : null
                            }

                            <UncontrolledDropdown>
                                <DropdownToggle nav caret>
                                    <FontAwesomeIcon icon={faGlobe} /> {' '}
                                    <Translate id="navbar.languages" options={{renderInnerHtml: true}}/>
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <LanguageSelectorMenu/>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
        );
    }
}